import "./style.scss";
import { SCREEN_LIST } from "../../../../hook/useScreen";
import { formatNumber } from "../../../../services/utility/utils";
import CircleNumber from "../../../CircleNumber";
// import CountDown from "../../../CountDown";
import EntryButton from "../EntryButton";
import { ReactComponent as IconUp } from "../../../../assets/images/icon-up.svg";
import { ReactComponent as IconDown } from "../../../../assets/images/icon-down.svg";
import { CircularProgress } from "@mui/material";
import { ReactComponent as IconBet } from "../../../../assets/images/icon-coin-bet.svg";
import { ReactComponent as Up } from "../../../../assets/images/icon-up.svg";
import { ReactComponent as Down } from "../../../../assets/images/icon-down.svg";
import CountDown from "../../../CountDown";
// import { calculateTimeLeft } from "../../../../utils/utils";
import { ReactComponent as Icon } from "../../../../assets/images/icon-how-to-play-1.svg";
import { Tooltip } from "react-tooltip";
import ContentBetFixedOdds from "./ContentBetFixedOdds";
import { ReactComponent as Warning } from "../../../../assets/images/warning.svg";
import {
  activeEventFathom,
  formatNumberForOdds,
} from "../../../../utils/utils";
import { useEffect, useMemo, useRef } from "react";

const HEAD_SHAKE = "animate__headShake";

export default function CartOpenedNew(props) {
  const {
    contest,
    heightScreen,
    handleClickTicket,
    type,
    loadingConfirm,
    isSuccess,
    wager,
    showAnimation,
    isError,
    time,
    operatorId,
    lang,
    isBet,
    isNextRound,
    fixedOdds,
    onConfirm,
    onCancel,
    isOddChange,
    oldOdd,
    isInsufficientFunds,
    onCloseInsufficientFunds,
    msgError,
    zIndex,
    onCloseErrorBet,
  } = props;

  const isMinHeight = heightScreen < SCREEN_LIST.screenHeight3;

  const refListOdds = useRef<any[]>([]);
  const refIsShowBlink = useRef<boolean>(false);

  useMemo(() => {
    if (contest?.whitelabelRektOdds && contest?.whitelabelMoonOdds) {
      const newOdds = {
        whitelabelMoonOdds: contest?.whitelabelMoonOdds,
        whitelabelRektOdds: contest?.whitelabelRektOdds,
      };
      const listOdds = refListOdds.current;
      if (!listOdds.length) {
        refListOdds.current = [...listOdds, newOdds];
        return;
      }
      const lastOdds = listOdds[listOdds.length - 1];
      if (lastOdds) {
        if (
          lastOdds.whitelabelMoonOdds !== newOdds.whitelabelMoonOdds ||
          lastOdds.whitelabelRektOdds !== newOdds.whitelabelRektOdds
        ) {
          refListOdds.current = [...listOdds, newOdds];
          refIsShowBlink.current = true;
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contest?.whitelabelMoonOdds, contest?.whitelabelRektOdds]);

  useEffect(() => {
    let t = null;
    if (refIsShowBlink.current) {
      t = setTimeout(() => {
        refIsShowBlink.current = false;
      }, 2000);
    }

    return () => {
      window.clearTimeout(t);
    };
  }, [refIsShowBlink.current]);

  const handleRenderIconArrow = (type: string) => {
    const listOdds = refListOdds.current;
    const length = listOdds.length;
    if (length < 2) {
      return "";
    }
    const oddLast = listOdds[length - 1];
    const oddPevLast = listOdds[length - 2];
    let isUp = false;

    if (type === "rekt") {
      if (oddLast.whitelabelRektOdds > oddPevLast.whitelabelRektOdds) {
        isUp = true;
      }
    }

    if (type === "moon") {
      if (oddLast.whitelabelMoonOdds > oddPevLast.whitelabelMoonOdds) {
        isUp = true;
      }
    }

    return (
      <svg
        width="8"
        height="7"
        viewBox="0 0 8 7"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`icon-arrow ${isUp && "icon-arrow-up"}`}
      >
        <path
          d="M4.38361 6.98218L0.834456 0.834869L7.93276 0.834869L4.38361 6.98218Z"
          fill="#211E42"
        />
      </svg>
    );
  };

  return (
    <div
      className={`wrapper-content-cart-ticket-opened 

      ${!fixedOdds && !isNextRound && "wrapper-content-cart-ticket-opened-last"}
        ${
          fixedOdds &&
          !contest?.whitelabelRektOdds &&
          !contest?.whitelabelMoonOdds &&
          "wrapper-content-cart-ticket-opened-last"
        }


      wrapper-content-cart-ticket-${type}
      ${isBet && "wrapper-content-cart-ticket-transition"}wrapper-logo
  ${
    ((fixedOdds &&
      !contest?.whitelabelRektOdds &&
      !contest?.whitelabelMoonOdds) ||
      isSuccess) &&
    "wrapper-content-cart-ticket-opened-fixedOdds"
  }
    
      `}
    >
      <div
        className={`contest-info ${type && "contest-info-selected"} ${
          isBet && "animate__animated"
        } ${type && "animate__fadeOut animate-delay-0"}
        ${isMinHeight && operatorId !== 1 && "contest-info-min"}
        `}
      >
        {isNextRound && !fixedOdds && (
          <>
            {!!contest?.whitelabelMoonOdds && !!contest?.whitelabelRektOdds && (
              <div className="rekt-odds">
                <p className="estimated-odds">
                  {lang?.estimated_odds || "Estimated Odds"}
                  <Icon
                    data-tooltip-id={`my-tooltip-${contest?.id}`}
                    data-tooltip-content={
                      lang?.content_tool_tip ||
                      "The “Up or Down” game uses Parimutuel markets. These odds are early estimates that change with everyone's bets. Final odds will be displayed once the round starts."
                    }
                    data-tooltip-place="bottom-start"
                  />
                </p>
                <p
                  className={`odds-value animate__animated 
            ${
              contest?.whitelabelMoonOdds &&
              "animate__bounceIn animate__slow animate-delay-02"
            }
            `}
                >
                  {formatNumberForOdds(contest?.whitelabelMoonOdds)}
                </p>
                {/* <div
            className={`odds-loading animate__animated
              ${contest?.whitelabelRektOdds && "animate__fadeOut"}
              `}
          /> */}
              </div>
            )}
            <CircleNumber contestLiveTime={contest?.contestLiveTime} />
            {!!contest?.whitelabelMoonOdds && !!contest?.whitelabelRektOdds && (
              <div className="moon-odds">
                <p className="estimated-odds">
                  {lang?.estimated_odds || "Estimated Odds"}
                  <Icon
                    data-tooltip-id={`my-tooltip-${contest?.id}`}
                    data-tooltip-content={
                      lang?.content_tool_tip ||
                      "The “Up or Down” game uses Parimutuel markets. These odds are early estimates that change with everyone's bets. Final odds will be displayed once the round starts."
                    }
                    data-tooltip-place="bottom-end"
                  />
                </p>
                <p
                  className={`odds-value animate__animated 
            ${
              contest?.whitelabelRektOdds &&
              "animate__bounceIn animate__slow animate-delay-02"
            }
            `}
                >
                  {formatNumberForOdds(contest?.whitelabelRektOdds)}
                </p>
                {/* <div
            className={`odds-loading animate__animated
              ${contest?.whitelabelMoonOdds && "animate__fadeOut"}`}
          /> */}
              </div>
            )}
          </>
        )}

        {fixedOdds && (
          <>
            {!!contest?.whitelabelMoonOdds && !!contest?.whitelabelRektOdds && (
              <div className="rekt-odds odds-fixed_odds">
                <div className="odds-content">
                  <p
                    className={`odds-value animate__animated 
              ${fixedOdds && "increase_size"}
              ${refIsShowBlink.current && "animate__pulse animate-delay-0"}
            `}
                  >
                    {formatNumberForOdds(contest?.whitelabelMoonOdds)}
                  </p>
                  {handleRenderIconArrow("moon")}
                </div>
                {refIsShowBlink.current && refListOdds.current.length > 1 && (
                  <div className="show-blink-rekt" />
                )}
                <div
                  className={`odds-loading animate__animated
              ${contest?.whitelabelMoonOdds && "animate__fadeOut"}
              `}
                  style={{
                    display: "none",
                  }}
                />
              </div>
            )}

            {!!contest?.whitelabelMoonOdds && !!contest?.whitelabelRektOdds && (
              <div className="moon-odds odds-fixed_odds">
                <div className="odds-content">
                  <p
                    className={`odds-value animate__animated 
              ${fixedOdds && "increase_size"}
              ${refIsShowBlink.current && "animate__pulse animate-delay-0"}
            `}
                  >
                    {formatNumberForOdds(contest?.whitelabelRektOdds)}
                  </p>
                  {handleRenderIconArrow("rekt")}
                </div>
                {refIsShowBlink.current && refListOdds.current.length > 1 && (
                  <div className="show-blink-moon" />
                )}
                <div
                  className={`odds-loading animate__animated
              ${contest?.whitelabelRektOdds && "animate__fadeOut"}`}
                  style={{
                    display: "none",
                  }}
                />
              </div>
            )}
          </>
        )}

        {fixedOdds &&
          !contest?.whitelabelMoonOdds &&
          !contest?.whitelabelRektOdds && (
            <div className={`wrap-next-round-last`}>
              {fixedOdds &&
                !contest?.whitelabelMoonOdds &&
                !contest?.whitelabelRektOdds && (
                  <p
                    className={`label_odds_will ${
                      isNextRound && "label_odds_will_next"
                    }`}
                  >
                    {lang?.odd_will_change || "Odds will be available soon"}
                  </p>
                )}
            </div>
          )}

        {!isNextRound && !fixedOdds && (
          <div className={`wrap-next-round-last`}>
            <CountDown
              expiryTime={contest?.contestLiveTime}
              prefix={lang?.starts_in}
            />
          </div>
        )}
      </div>

      {!isOddChange && (
        <div
          className={`entry-buttons animate__animated
         ${
           type &&
           isBet &&
           (fixedOdds
             ? `animate__fadeOut animate-delay-0`
             : `animate__fadeOut animate-delay-06`)
         }

         ${
           type &&
           !isBet &&
           `animate__fadeOut animate-delay-0 animate-duration-0`
         }
         `}
        >
          <div
            className={`animate__animated ${
              showAnimation && HEAD_SHAKE
            } animate-delay-24`}
          >
            <EntryButton
              direction="above"
              onClick={() => {
                handleClickTicket("above");
                activeEventFathom(`BetBtn-Up-Card${zIndex}`);
              }}
              operatorId={operatorId}
            >
              <IconUp />
            </EntryButton>
          </div>
          <div
            className={` ${isBet && "animate__animated"} ${
              showAnimation && HEAD_SHAKE
            } animate-delay-28`}
          >
            <EntryButton
              direction="below"
              onClick={() => {
                handleClickTicket("below");
                activeEventFathom(`BetBtn-Down-Card${zIndex}`);
              }}
              operatorId={operatorId}
            >
              <IconDown />
            </EntryButton>
          </div>
        </div>
      )}

      {!fixedOdds && (
        <div className={`wrap-card-loading-confirm ${type}-select`}>
          <div
            className={`wrap-content animate__animated  
          ${type && isBet && `animate__fadeIn animate-delay-09`}
          ${
            type &&
            !isBet &&
            `animate__fadeIn animate-delay-0 animate-duration-0`
          }
          ${!type && "animate__fadeOut "}`}
          >
            <p
              className={`label-placing-bet animate__animated 
          ${
            isSuccess && isBet && !isError && "animate__fadeIn animate-delay-12"
          }
          ${
            isSuccess &&
            !isBet &&
            !isError &&
            "animate__fadeIn animate-delay-0 animate-duration-0"
          }
          ${
            time <= 1 &&
            !isError &&
            "animate__fadeOut animate-delay-0 animate__fast"
          }
          `}
            >
              {lang?.bet_confirmed || "Bet Confirmed !"}
            </p>

            {type && (
              <div
                className={`${
                  (loadingConfirm || isSuccess) && "content"
                } animate__animated animate-delay-12
            ${loadingConfirm && "animate__fadeIn"}
            ${isSuccess && "content-success"}
          `}
              >
                {/* loading */}
                <p
                  className={`label-placing-bet animate__animated animate-delay-0
                  ${loadingConfirm && `animate__fadeIn animate-delay-12`}

                  ${!loadingConfirm && isBet && "animate__fadeOut"}
                  ${
                    !loadingConfirm &&
                    !isBet &&
                    "animate__fadeOut animate-duration-0"
                  }
            `}
                >
                  {lang?.placing_bet || "Placing Bet"}
                </p>

                <div
                  className={`animate__animated animate__slow
            ${loadingConfirm && `animate__fadeIn animate-delay-14`}
            ${
              !loadingConfirm &&
              "animate__fadeOut animate-delay-0 animate-duration-0"
            }
            `}
                >
                  <CircularProgress
                    size={40}
                    className="circular-progress"
                    style={{
                      color: "#050503",
                    }}
                  />
                </div>

                {/* success */}
                {!isError && (
                  <div
                    className={`wrap-icon-up-down ${
                      isSuccess &&
                      isBet &&
                      !loadingConfirm &&
                      "wrap-icon-up-down-animation"
                    } animate__animated
            ${
              isSuccess &&
              !isError &&
              isBet &&
              `animate__fadeIn animate-delay-09`
            }

            ${
              isSuccess &&
              !isError &&
              !isBet &&
              `animate__fadeIn animate-delay-0 animate-duration-0`
            }

            ${time <= 2 && "animate__fadeOut animate-delay-04"}

            `}
                  >
                    {type === "below" ? <Down /> : <Up />}
                    <div className="wrap-start-time">
                      <CountDown
                        expiryTime={contest?.contestLiveTime}
                        prefix={lang?.starts_in}
                      />
                    </div>
                  </div>
                )}
                {/* error */}

                {isBet && (
                  <span
                    className={`shimmer animate__animated animate__delay-2s
             ${isSuccess && "animate__fadeIn"}
            `}
                  ></span>
                )}
              </div>
            )}

            {type && isError && (
              <div
                className={`wrap-error animate__animated
             ${isError && "animate__fadeIn animate-delay-09"}
             ${time <= 1 && isError && "animate__fadeOut animate-delay-0"}
             `}
              >
                Bet error!
              </div>
            )}

            <div
              className={`loading-confirm animate__animated animate__slow
           ${
             isSuccess &&
             isBet &&
             !isError &&
             "animate__fadeIn animate-delay-14"
           }
           ${
             isSuccess &&
             !isBet &&
             !isError &&
             "animate__fadeIn animate-delay-0 animate-duration-0"
           }

           ${time <= 3 && !isError && "animate__fadeOut animate-delay-02"}
          `}
            >
              <IconBet />
              <span>${formatNumber(wager)}</span>
            </div>
          </div>
        </div>
      )}

      {fixedOdds && type && (
        <ContentBetFixedOdds
          type={type}
          loadingConfirm={loadingConfirm}
          isBet={isBet}
          isSuccess={isSuccess}
          wager={wager}
          isOddChange={isOddChange}
          onConfirm={onConfirm}
          onCancel={onCancel}
          contest={contest}
          oldOdd={oldOdd}
          lang={lang}
          msgError={msgError}
          isError={isError}
        />
      )}

      {!type && !fixedOdds && <Tooltip id={`my-tooltip-${contest?.id}`} />}

      {isInsufficientFunds && (
        <div className="wrap-isInsufficientFunds">
          <div className="wrap-title">
            <Warning />{" "}
            <p className="title">
              {lang?.insufficient_funds || "Insufficient Funds"}
            </p>
          </div>
          <div className="wrap-content">
            <p
              className="label"
              dangerouslySetInnerHTML={{
                __html:
                  lang?.insufficient_funds_content ||
                  "Insufficient funds to place your bet.<br /><br />Please review the bet amount or make a new deposit to continue playing",
              }}
            />

            <div
              className="btn-cancel"
              onClick={(e) => {
                e.stopPropagation();
                onCloseInsufficientFunds?.();
              }}
            >
              {lang?.close || "Close"}
            </div>
          </div>
        </div>
      )}

      {isError && !isOddChange && (
        <div className="wrap-isInsufficientFunds">
          <div className="wrap-title">
            <Warning />{" "}
            <p className="title">{lang?.bet_not_placed || "Bet not placed"}</p>
          </div>
          <div className="wrap-content">
            <p
              className="label"
              dangerouslySetInnerHTML={{
                __html:
                  lang?.bet_not_placed_content ||
                  "Due to technical issues your bet couldn’t be placed.<br/><br/>Please try again.",
              }}
            />

            <div
              className="btn-cancel"
              onClick={(e) => {
                e.stopPropagation();
                onCloseErrorBet?.();
              }}
            >
              {lang?.close || "Close"}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
